import * as angular from 'angular';
import { MeurhAdmissoesestagiarioValetransportepersonalizadoFormmodalController } from './valetransportepersonalizado.formmodal.controller';

export class MeurhAdmissoesestagiarioValetransportepersonalizadoFormmodalComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesestagiarioValetransportepersonalizadoFormmodalComponent';
	static controller = MeurhAdmissoesestagiarioValetransportepersonalizadoFormmodalController;
	static template = require('!!html-loader!./valetransportepersonalizado.formmodal.html');
	static transclude = true;
	static bindings = {
		valetransportepersonalizado: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
